<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      top="2vh"
      :close-on-click-modal="false"
      width="70%"
    >
      <div class="header-actions">
        <search-input
          placeholder="Поиск по ФИО"
          style="width: 300px"
          v-model="search"
          @change="loadAxisUserPositions"
        >
        </search-input>
      </div>
      <p>Найдено пользователей: {{ paginator ? paginator.totalCount : 0 }}</p>
      <el-table :data="axis_user_positions" border v-loading="loading">
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column width="200" label="Потенциал">
          <template v-slot="scope">
            {{ scope.row.potential_value }}
            <el-tooltip v-if="scope.row.potential_card_id" content="Перейти в карту" placement="top">
              <router-link
                class="table-router-link"
                :to="{ name: 'Card', params: { id: scope.row.potential_card_id } }"
                target="_blank"
              >
                <el-button
                  class="table-action-button"
                  round
                  size="mini"
                  icon="fas fa-external-link-alt"
                >
                </el-button>
              </router-link>
            </el-tooltip>
            <el-tooltip v-if="scope.row.potential_evaluation_id" content="Смотреть отчет по оценке" placement="top">
              <el-button
                class="table-action-button"
                round
                size="mini"
                icon="fas fa-chart-bar"
                @click="showEvaluateResult(scope.row.user, scope.row.potential_evaluation_id)"
              >
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column width="200" label="Производительность">
          <template v-slot="scope">
            {{ scope.row.productivity_value }}
            <el-tooltip v-if="scope.row.productivity_card_id" content="Перейти в карту" placement="top">
              <router-link
                class="table-router-link"
                :to="{ name: 'Card', params: { id: scope.row.productivity_card_id } }"
                target="_blank"
              >
                <el-button
                  class="table-action-button"
                  round
                  size="mini"
                  icon="fas fa-external-link-alt"
                >
                </el-button>
              </router-link>
            </el-tooltip>
            <el-tooltip v-if="scope.row.productivity_evaluation_id" content="Смотреть отчет по оценке" placement="top">
              <el-button
                class="table-action-button"
                round
                size="mini"
                icon="fas fa-chart-bar"
                @click="showEvaluateResult(scope.row.user, scope.row.productivity_evaluation_id)"
              >
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadAxisUserPositions"
      ></paginator>
    </el-dialog>

    <evaluate-result-dialog
      ref="evaluateResultDialog"
    >
    </evaluate-result-dialog>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import EvaluateResultDialog from "@/modules/evaluation/components/evaluation/EvaluateResultDialog.vue";

export default {
  name: "talent-matrix-cell-user-information-dialog",
  components: {
    EvaluateResultDialog,
    SearchInput,
    Paginator,
  },
  data() {
    return {
      search: '',
      cellId: null,
      matrixId: null,
      title: '',
      show: false,
      loading: false,
      axis_user_positions: [],
      filters: {
        positions: [],
        group_ids: [],
        companies: [],
        subdivisions: [],
      },
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mixins: [paginator],
  methods: {
    async open(cell, filters) {
      this.filters = filters;
      this.title = cell.name;
      this.cellId = cell.id;
      this.matrixId = cell.matrix_id;
      this.search = '';
      this.axis_user_positions = [];

      this.loadAxisUserPositions();
      this.show = true;
    },
    showEvaluateResult(user, evaluationId) {
      this.$refs.evaluateResultDialog.open(user, evaluationId);
    },
    close() {
      this.show = false;
    },
    loadAxisUserPositions() {
      this.loading = true;
      this.$api.talentMatrix.matrixCellUserPositionsSearch({
        ...this.filters,
        search: this.search,
        cell_ids: [ this.cellId],
        matrix_id: this.matrixId,
        table_view: true,
        expand: ['user'].join(),
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.axis_user_positions = data.axis_user_positions;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
  }
}
</script>

<style scoped>
 .header-actions {
   margin-bottom: 20px;
 }
</style>